export default function CopyAllIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 18.5V16.5H5V18.5H3ZM3 15V13H5V15H3ZM3 11.5V9.5H5V11.5H3ZM6.5 22V20H8.5V22H6.5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM10 22V20H12V22H10ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20H5V22ZM13.5 22V20H15.5C15.5 20.55 15.3042 21.0208 14.9125 21.4125C14.5208 21.8042 14.05 22 13.5 22ZM3 8C3 7.45 3.19583 6.97917 3.5875 6.5875C3.97917 6.19583 4.45 6 5 6V8H3Z"
        fill="#85858B"
      />
    </svg>
  );
}
